import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MessageSquare } from 'lucide-react';

export default function Homepage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-4xl w-full text-center">
        {/* Logo and Brand */}
        <div className="flex items-center justify-center gap-3 mb-8 pt-8 md:pt-0">
          <img src="/IBC-Icon.png" alt="IcebreakChat Icon" className="h-16 w-16" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            IcebreakChat
          </h1>
        </div>

        {/* Hero Heading */}
        <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-gray-800 leading-tight">
          AI-Powered Customer Support
          <br />
          <span className="text-blue-600">That Works 24/7</span>
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
          Join our private beta and transform your customer support with intelligent AI automation.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button 
            size="lg" 
            onClick={() => navigate('/register')} 
            className="bg-blue-600 hover:bg-blue-700 text-lg h-14 px-10"
          >
            Sign Up for Beta
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={() => navigate('/login')} 
            className="text-lg h-14 px-10 border-2"
          >
            Log In
          </Button>
        </div>

        {/* Beta Badge */}
        <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
          <MessageSquare className="w-4 h-4" />
          <span>Private Beta • Limited Access</span>
        </div>

        {/* Simple Feature List */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-3xl mb-3">⚡</div>
            <h3 className="font-semibold text-gray-900 mb-2">Instant Setup</h3>
            <p className="text-gray-600 text-sm">Get started in minutes</p>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-3">🤖</div>
            <h3 className="font-semibold text-gray-900 mb-2">GPT-4o Powered</h3>
            <p className="text-gray-600 text-sm">Human-like responses</p>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-3">📊</div>
            <h3 className="font-semibold text-gray-900 mb-2">Analytics</h3>
            <p className="text-gray-600 text-sm">Track every conversation</p>
          </div>
        </div>
      </div>
    </div>
  );
}
